
Checkout.Submit = function(checkout, config) {
	var _cos = this;

	var config = $.extend({
		// defaults
		'onFails' : []
	}, (config || {}));

	var request = false,
		logoutWarning = false,
		totalWarnings = [];

	var init = function() {
		publish();
	}

	var publish = function() {
		_cos.submit = submit;
	}

	var submit = function(data) {

		if (
			request
			|| !data
		)
			return false;

		request = checkout.remote.call({
			'type' : 'POST',
			'data' : data
		})
			.done(done)
			.fail(fail)
			.always(always);

		return true;
	}

	var done = function(response) {

		var firstInvalidStep = false;

		if (response.data.successURL) {
			$(window).unbind('beforeunload');
			window.location = fixNavState(response.data.successURL);
			return;
		}

		if (response.data.errors) {
			$.each(response.data.errors, function(i, error) {
				var invalidStep = showError(error);

				if (
					!firstInvalidStep
					&& invalidStep
				)
					firstInvalidStep = invalidStep;

			});
		}

		if (firstInvalidStep) {
			if (firstInvalidStep == 'stop')
				return;
			else
				checkout.scrollToInvalidStep(checkout[firstInvalidStep]);
		}

		var confirmReloadMsg = false;

		if (logoutWarning)
			confirmReloadMsg = 'You have been logged out. Page must be refreshed';
		else if (totalWarnings.length)
			confirmReloadMsg =
				'Order Totals have changed. Page must be refreshed.' + "\n\n"
				+ "Reasons:\n - "+totalWarnings.join("\n - ");

		if (
			confirmReloadMsg
			&& confirm(confirmReloadMsg)
		) {
			location.reload(true);
			return;
		}

		fail();
	}

	var fail = function(request) {
		var alertMsg;

		$.each(config.onFails, function(i, onFail) {
			onFail(request);
		});

		if (request)
			alertMsg = (checkout.remote.getErrorMsg(request) || 'Unknown Order-Submit Response Type');

		if (
			alertMsg
			&& alertMsg != 'version mismatch'
		)
			alert('Submit Order Error: ' + alertMsg);

	}

	var always = function() {
		request = false;
		logoutWarning = false;
		totalWarnings = [];
	}

	var showError = function(error) {

		if (!error.code)
			return;

		if (error.code == 'cartContents') {
			checkout.cart.updateItems(error.data, error.msg);
			return 'cart';
		}

        if (error.code == 'refreshShipQuote') {
            alert('Shipping must be refreshed due to Shipping Address');
            checkout.cart.totals.calc(true);
            return 'cart';
        }

        if (error.code == 'shippingService') {
            checkout.cart.shipping.error(error.msg);
            return 'cart';
        }
		else if (error.code == 'shippingAddress') {
			checkout.cart.shipping.showErrors(error.data);
			return 'cart';
		}

		else if (error.code == 'billship') {
			checkout.billship.fieldErrors(error.data);
			return 'billship';
		}

		else if (error.code == 'billShipChanged') {
			checkout.session.set(error.data);
			checkout.billship.error(error.msg);
			checkout.billship.prefillForm();
			checkout.billship.saved = false;
			return 'billship';
		}

		else if (error.code == 'payment') {
			if (checkout.payment) {
				checkout.payment.error(error.msg);
				return 'payment';
			} else {
				alert(error.msg);
				return;
			}
		}

		else if (error.code == 'cancelPayPal') {

			$.each(checkout.payment.getMethodsByType('paypal'), function(i, method) {
				method.cancel();
			});

			checkout.payment.error(error.msg);
			return 'payment';
		}

		else if (error.code == 'paymentMethodAmounts') {
			checkout.payment.methodAmountsInvalid(error.increaseAmt, error.decreaseAmt);
			return 'payment';
		}

		else if (error.code == 'paymentMethod') {
			checkout.payment.methodInvalid(error.idx, error.error);
			return 'payment';
		}

		else if (error.code == 'paymentMethodAmount') {
			checkout.payment.methodAmountInvalid(error.idx);
			return 'payment';
		}

		else if (error.code == 'paymentMethodFields') {
			checkout.payment.methodFieldErrors(error.idx, error.error);
			return 'payment';
		}

		else if (error.code == 'paypalRedirect') {
			window.location = error.URL;
			return 'stop';
		}

		else if (error.code == 'login')
			logoutWarning = true;

		else if (error.code == 'totals')
			totalWarnings.push(error.msg);

	}

	init()
}

